module.exports = __webpack_public_path__ + "static/media/menu-icon.6c44238f.svg";